import { SOGetProject } from '../project/so-get-project';
import { SOGetOrganization } from '../organization/so-get-organization';


export class SOPutAssessment {

  constructor(
    public uid: string,
    public project: SOGetProject = null,
    public organization: SOGetOrganization = null,
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOPutAssessment(
      'uid' in params ? params.uid : null,
      'project' in params ? params.project : null,
      'organization' in params ? params.organization : null,
    );
  }
}
